module.exports = __webpack_public_path__ + "img/01.e4cdb581.jpg";